import { render, staticRenderFns } from "./confirm-delete-vendor-dialog.vue?vue&type=template&id=25149216&scoped=true"
import script from "./confirm-delete-vendor-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-delete-vendor-dialog.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-vendor-dialog.vue?vue&type=style&index=0&id=25149216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25149216",
  null
  
)

export default component.exports